exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n/*created by AHMED HAYEL*/\r\n\r\n.card-header{\r\n  \r\n  padding:10px;\r\n  padding-left:15px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-component/compte-details/compte-details.component.css
// module id = 313
// module chunks = 1